module.exports = __webpack_public_path__ + "img/apoio-herbario-tefh.6e6bc043.png";